/* INNERSLF theme — global JS.
   Most interactivity is bundled per-section via {% javascript %} blocks. */
(function () {
  "use strict";

  /* Scroll-reveal: fade-up elements marked [data-reveal] as they enter view.
     Mirrors the Reveal/ImageReveal components from the Next.js site.

     Robustness notes:
     - Content is visible by default (CSS gated on html:not(.no-js)), so it is
       never permanently hidden if JS fails.
     - check() re-queries the DOM each pass (matching :not(.is-in)), so it works
       even if sections render late or are replaced by hot-reload.
     - Listeners are always attached; we also poll a few times after load to
       catch any late layout. */
  function revealNow() {
    document.querySelectorAll("[data-reveal]").forEach(function (el) {
      el.classList.add("is-in");
    });
  }

  function initReveal() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      revealNow();
      return;
    }

    function check() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var remaining = 0;
      document.querySelectorAll("[data-reveal]:not(.is-in)").forEach(function (el) {
        if (el.getBoundingClientRect().top < vh * 0.9) {
          var d = el.getAttribute("data-reveal-delay");
          if (d) el.style.transitionDelay = d + "ms";
          el.classList.add("is-in");
        } else {
          remaining++;
        }
      });
      return remaining;
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { check(); ticking = false; });
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", check);
    window.addEventListener("load", check);

    // Initial + a few delayed sweeps to catch late-rendered sections.
    check();
    [120, 400, 1200].forEach(function (t) { window.setTimeout(check, t); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initReveal);
  } else {
    initReveal();
  }
})();
